import { render, staticRenderFns } from "./DataTableRow.vue?vue&type=template&id=1923b408&scoped=true"
import script from "./DataTableRow.vue?vue&type=script&lang=js"
export * from "./DataTableRow.vue?vue&type=script&lang=js"
import style0 from "./DataTableRow.vue?vue&type=style&index=0&id=1923b408&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1923b408",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
